module.exports = __webpack_public_path__ + "img/empty_illustration_new.72f6fc4d.png";